import Logo from '../logo'

export function LoginPageHeader () {
    return (
        <header className="login-page-header">
            <div className='layout'>
                <Logo />
            </div>
        </header>
    )
}
